/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ArgonButton from "components/ArgonButton";
import { Link } from "react-router-dom";

const BannerTableData = (banners, handleDeleteClick, refreshData) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "Banner", align: "left" },
    { name: "Status", align: "left" },
    { name: "title", align: "left" },
    { name: "Banner type", align: "left" },
    { name: "action", align: "center" },
  ],

  rows: banners.map((banner, index) => {
    // Get status badge color
    const getStatusColor = (status) => {
      switch (status) {
        case "ACTIVE":
          return "success";
        case "INACTIVE":
          return "secondary";
        case "PENDING":
          return "warning";
        default:
          return "info";
      }
    };

    return {
      sno: (
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {index + 1}
        </ArgonTypography>
      ),
      Banner: (
        <ArgonBox display="flex" alignItems="center">
          <img
            src={banner.bannerImage}
            alt={banner.title}
            style={{
              width: "100px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #d2d6da",
            }}
          />
        </ArgonBox>
      ),
      Status: (
        <ArgonBadge
          variant="gradient"
          badgeContent={banner.status}
          color={getStatusColor(banner.status)}
          size="xs"
          container
        />
      ),
      title: (
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {banner.title?.substring(0, 50) || "N/A"}
          {banner.title?.length > 50 && "..."}
        </ArgonTypography>
      ),
      "Banner type": (
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {banner.bannerType || "N/A"}
        </ArgonTypography>
      ),
      action: (
        <ArgonBox display="flex" alignItems="center" gap={0}>
          {/* Edit Icon */}
          <Link to={`/banner/editbanner/${banner._id}`} style={{ textDecoration: "none" }}>
            <ArgonButton variant="text" size="large" sx={{ minWidth: "12px", p: 0 }}>
              <EditIcon color="info" />
            </ArgonButton>
          </Link>
          {/* Delete icon */}
          <ArgonButton
            variant="text"
            size="large"
            sx={{ minWidth: "32px", p: 0 }}
            onClick={() => handleDeleteClick(banner._id)}
          >
            <DeleteIcon color="error" />
          </ArgonButton>
        </ArgonBox>
      ),
    };
  }),
});

export default BannerTableData;
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">2</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9123456789</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">12 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" fontWeight="medium" color="text">3</ArgonTypography>,
//     mobile: <ArgonTypography variant="caption" fontWeight="medium" color="text">9988776655</ArgonTypography>,
//     "Added on": <ArgonTypography variant="caption" fontWeight="medium" color="text">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//           <VisibilityIcon color="primary"/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>

//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{2}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>

//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{3}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>

//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{4}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>

//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{5}</ArgonTypography>,
//       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"}/>,
//       MobileNo: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"6260524679"}</ArgonTypography>,
//       JoiningDate: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"14 July 2024"}</ArgonTypography>,
//       city:<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Bhopal"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={1}>
//            {/* View Icon */}
//            <ArgonTypography variant="body1" component="a" href="#" color="primary" fontWeight="medium">
//             <VisibilityIcon color="primary"/>
//            </ArgonTypography>

//            {/* Delete Icon */}
//            <ArgonTypography  component="a" href="#" variant="body1" color="error" fontWeight="medium">
//              <DeleteIcon/>
//            </ArgonTypography>
//          </ArgonBox>
//        ),
//     },

// //      {
// //       sno:"2",
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //        action: (
// //          <ArgonBox display="flex" alignItems="center" gap={1}>
// //            {/* View Icon */}
// //            <ArgonTypography
// //              component="a"
// //              href="#"
// //              variant="caption"
// //              color="primary"
// //              fontWeight="medium"
// //            >
// //              <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //            </ArgonTypography>

// //            {/* Delete Icon */}
// //            <ArgonTypography
// //              component="a"
// //              href="#"
// //              variant="caption"
// //              color="error"
// //              fontWeight="medium"
// //            >
// //              <DeleteIcon/>
// //            </ArgonTypography>
// //          </ArgonBox>
// //        ),
// //       },
// //      {
// //       sno:"3",
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>

// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },
// //      {
// //      sno:(<ArgonTypography variant="caption">5</ArgonTypography>),
// //    profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:(<ArgonTypography variant="caption">7354722929</ArgonTypography>),
// //       JoiningDate:(<ArgonTypography variant="caption">24 july </ArgonTypography>),
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>

// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },
// //      {
// //       sno:(<ArgonTypography variant="caption">5</ArgonTypography>),
// //       profile:<Author image={team2} name={"John Michael"} email={"john@creative-tim.com"} />,
// //       MobileNo:"7354722929",
// //       JoiningDate:"2024-01-15 16:00:00",
// //       city:"Bhopal",
// //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
// //       action: (
// //         <ArgonBox display="flex" alignItems="center" gap={1}>
// //           {/* View Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="primary"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-eye-fill" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>

// //           {/* Delete Icon */}
// //           <ArgonTypography
// //             component="a"
// //             href="#"
// //             variant="caption"
// //             color="error"
// //             fontWeight="medium"
// //           >
// //             <i className="ri-delete-bin-6-line" style={{ fontSize: "18px", cursor: "pointer" }}></i>
// //           </ArgonTypography>
// //         </ArgonBox>
// //       ),
// //       // action:( <ArgonTypography  component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
// //     },

//     // {
//     //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Organization" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       23/04/18
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },

//     // {
//     //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       11/01/19
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
//     //   function: <Function job="Executive" org="Projects" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       19/09/17
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       24/12/08
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Executive" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       04/10/21
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
//     //   function: <Function job="Programtor" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       14/09/20
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
